import apiClient from './apiClient';
import { cleanParams } from '@/utils/buildQuery';

const base = '/admin/scraper';

export const scraperService = {
  sources: (params) => apiClient.get(`${base}/sources`, { params: cleanParams(params) }),
  updateSource: (id, payload) => apiClient.patch(`${base}/sources/${id}`, payload),
  run: (payload) => apiClient.post(`${base}/run`, payload),
  enrich: (payload) => apiClient.post(`${base}/enrich`, payload),
  buildQuiz: (payload) => apiClient.post(`${base}/quiz`, payload),
  runs: (params) => apiClient.get(`${base}/runs`, { params: cleanParams(params) }),
  job: (jobId) => apiClient.get(`${base}/jobs/${jobId}`),
};

export default scraperService;
